module.exports = __webpack_public_path__ + "img/icon-custom-grid.816b58b9.png";